"use client";

import useScroller from "@/hooks/useScroller.hook";
import { useUIStore } from "@/stores/ui-states.store";
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

type StyleControllerContextType = ReturnType<typeof useStyleControls>;

export const StyleControllerContext = createContext<StyleControllerContextType>(
  {} as StyleControllerContextType,
);

const useStyleControls = () => {
  const [isLinesVisible, setIsLinesVisible] = useState(false);

  const scrollY = useScroller();

  useEffect(() => {
    if (scrollY > 1) setIsLinesVisible(false);
    else setIsLinesVisible(true);
  }, [scrollY]);

  const scrollDownBtnRef = useRef<HTMLButtonElement>(null);
  const textContainerRef = useRef<HTMLDivElement>(null);
  const canvasContainerRef = useRef<HTMLDivElement>(null);
  const scrollDownTarget = useRef<HTMLDivElement>(null);

  const refControl = {
    scrollDownBtnRef,
    textContainerRef,
    canvasContainerRef,
    scrollDownTarget,
  };

  return {
    scrollY,
    refControl,
    isLinesVisible,
  };
};

export const StyleControlsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const stylesControl = useStyleControls();

  return (
    <StyleControllerContext.Provider value={stylesControl}>
      {children}
    </StyleControllerContext.Provider>
  );
};

export const useStyleController = (): StyleControllerContextType => {
  const styleControls = useContext(StyleControllerContext);
  if (styleControls === undefined) {
    throw new Error(
      "Style controller must be used within the StyleControlsProvider!",
    );
  }
  return styleControls;
};
